// Chrome 152 formatea el peso colombiano sin decimales (Node 22 todavía le da dos), así que los
// comprobantes redondeaban los centavos según el navegador. Se fijan los dos decimales.
const formatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
})

// Props comunes de los campos de valor en pesos (react-currency-input-field). La librería saca los
// separadores del formato de moneda de Intl; si el navegador no le da decimales al peso, se queda
// sin separador decimal y descarta la coma: "8.070.003,52" quedaba en 807.000.352. Con los
// separadores explícitos no depende del navegador.
export const copInputProps = {
    intlConfig: { locale: 'es-CO', currency: 'COP' },
    decimalSeparator: ',',
    groupSeparator: '.',
}

export const formatterId = num => {
    return new Intl.NumberFormat('es-Es').format(num)
} 

export const currencyFormat = num => {
    return num ? formatter.format(num) : num
}